/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty-pattern */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Button, Divider, Grid, Link, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import GetAppIcon from '@material-ui/icons/GetApp';
import PregnantDocumentsModal from "./pregnantDocumentsModal";
import PregnantFilesModal from "../pregnant/pregnantFilesModal";
import { uploadFilesAsync } from "../../actions/licence-motherhood-actions";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import PregnantEditForm from "./pregnantEditForm";
import { useStateValue } from "../../context/store";
import LactationCalculationModal from "./lactationCalculationModal";
import utils from "../../utils/utils";
import { permissionsConstans } from "../../constansPermissions";
import moment from "moment";
import AdjuntarIcon from "@material-ui/icons/AttachFileOutlined";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: "165px",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));


const PregnantAccordion = (props) => {
  const {
    headers,
    data,
    handleCancel,
    maestras,
    hasEdition,
    setHasEdition
  } = props;

  const classes = useStyles();
  const [{ }, dispatch] = useStateValue();
  const id = IdKey.generate();
  const [showPregnantDocumentsModal, setShowPregnantDocumentsModal] = useState(false);
  const [showLactationCalculationModal, setShowLactationCalculationModal] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [permissions, setPermissions] = useState(utils.validationPermissions("MAT_LIC"));
  const [licenseEndDateValue, setLicenseEndDateValue] = useState(null);
  const licenseStartDateValue = moment(data.estimatedDueDate).add(1, 'days');

  const calculateLactationFinishDate = (value) => {
    let lactancyFinishDate = moment(value).add(6, 'months');
    setLicenseEndDateValue(lactancyFinishDate);
  }

  useEffect(() => {
    calculateLactationFinishDate(licenseStartDateValue);
  }, [data.estimatedDueDate])

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }

        if (header.field === "status") {
          return object[header.field]
            ?.replaceAll("_", " ")
            .replace("cion", "ción");
        }
        if (header.field.includes("Date")) {
          let fechaFormato = object[header.field];
          var fecha = fechaFormato ? fechaFormato.split("T")[0] : null;
          return fecha ? moment(fecha).format("DD/MM/YYYY") : "";
        }
        return object[header.field];
      }
      return "";
    }
    if (header.title === "Regional") {
      return object[header.field][header.child]?.code ? object[header.field][header.child]?.code : "";
    } else if (header.title === "Cargo") {
      return object[header.field][header.child]?.denomination ? object[header.field][header.child]?.denomination : "";
    } 
    else {
      return object[header.field] !== null
        ? object[header.field][header.child]
        : "";
    }
  };

  const handleDownloadFiles = (licenceId) => {
    setShowPregnantDocumentsModal(true);
  }

  const handleLactationCalculation = (licenceId) => {
    setShowLactationCalculationModal(true);
  }

  const handleEdit = () => {
    setShowEditForm(true);
    setShowDetails(false);
  }

  const handleShowDetails = () => {
    setShowEditForm(false);
    setShowDetails(true);
  }


  const showDownloadFilesButton = (id) => {
    return (
      <Tooltip title="Descargar archivos" arrow placement="top">
        <GetAppIcon
          onClick={() => handleDownloadFiles(id)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent}
        />
      </Tooltip>
    )
  }

  const showEditButton = (id, status) => {
    const licenceEnd = data?.licenseEndDate ? new moment(data?.licenseEndDate).startOf('day') : null;
    const isValidDate = licenceEnd ? licenceEnd.startOf('day').diff(moment(), 'days') > 0 : false;
    return (
      status !== "ANULADA" && isValidDate && <Tooltip title="Editar" arrow placement="top">
        <EditIcon
          onClick={() => handleEdit(id)}
          className={classes.iconEvent}
          style={{ fontSize: 40, pointerEvents: "auto" }}
        />
      </Tooltip>
    )
  }

  const showDetailsButton = (id) => {
    return !showDetails && (
      <Tooltip title="Ver detalle" arrow placement="top">
        <VisibilityIcon
          onClick={() => handleShowDetails(id)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent} />
      </Tooltip>
    )
  }

  const hideDetailsButton = () => {
    return showDetails && (<Tooltip title="Ocultar detalle" arrow placement="top">
      <VisibilityOffIcon
        onClick={() => setShowDetails(false)}
        style={{ fontSize: 40, pointerEvents: "auto" }}
        className={classes.iconEvent} />
    </Tooltip>)
  }

  const onClosePregnantDocumentsModal = () => {
    setShowPregnantDocumentsModal(false);
    setShowMessage(false);
  };

  const onCloseLactationCalculationModal = () => {
    setShowLactationCalculationModal(false);
    setShowMessage(false);
  };

  //Modal Add files
  const [documents, setDocuments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const handleClickClose = () => {
    setShowMessage(false);
  };

  const [message, setMessage] = useState({
    description: '',
    textButtonSubmit: '',
    handleClick: () => handleClickClose(),
    oneButtons: true,
    type: 'WARNING',
    open: false
  });

  const uploadFiles = async () => {

    const response = await uploadFilesAsync(data.id, documents);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setShowMessage(true);
      setMessage({
        description: `Se han cargado los archivos de forma exitosa.`,
        textButtonSubmit: "Volver",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setShowMessage(true);
      setMessage({
        description: `No se han cargado los archivos, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setShowMessage(true);
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  }

  const onClose = (accept) => {
    if (accept && documents?.length > 0) {
      uploadFiles();
    } else if (accept && documents?.length === 0) {
      setShowMessage(true);
      setMessage({
        description: `No se ha adjuntado ningún archivo`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
    setOpenModal(false);
  };

  const handleUploadFiles = (id) => {
    setOpenModal(true);
  }

  const showUploadFilesButton = (id, status) => {
    return (
      status !== "ANULADA" && <Tooltip title="Adjuntar archivos" arrow placement="top">
        <AdjuntarIcon
          onClick={() => handleUploadFiles(id)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent}
        />
      </Tooltip>
    )
  }

  const showCalculationLactancyLink = () => {
    //const testDate = new moment("2022-12-21 09:0:0").startOf('day');
    const licenceEnd = data?.licenseEndDate ? new moment(data?.licenseEndDate).startOf('day') : null;
    //const isValidDate = licenceEnd ? moment(testDate).diff(licenceEnd, 'days') >= 1 : false;
    const isValidDate = licenceEnd ? moment().startOf('day').diff(licenceEnd, 'days') > 0 : false;
    const showLink = data.status === "ACTIVA" && isValidDate;

    return (showLink &&
      <Link
        style={{ pointerEvents: "auto" }}
        disabled href="#"
        onClick={() => handleLactationCalculation(id)}
      >
        Cálculo de lactancia
      </Link>
    )
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const showCancelRecordButton = (id, status) => {
    const showButton = status !== "ANULADA" && permissions?.functionalities?.some(
      (x) => x === permissionsConstans.MAT_LIC_ANULAR
    );
    return (
      showButton && <Grid item xs={2}>
        <Button
          variant="contained"
          className={classes.buttonSearch}
          onClick={() => handleCancel(id)}
        >
          Anular registro
        </Button>
      </Grid>
    )
  }

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
        expanded={showDetails || showEditForm}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            {showCalculationLactancyLink()}
          </div>
          <div className={classes.columnEvent}>
            &nbsp;&nbsp;
            {showEditButton(data?.id, data?.status)}
            &nbsp;&nbsp;
            {showUploadFilesButton(data?.id, data?.status)}
            &nbsp;&nbsp;
            {showDetailsButton(data.id)}
            &nbsp;&nbsp;
            {hideDetailsButton()}
            &nbsp;&nbsp;
            {showDownloadFilesButton(data.id)}
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          {showEditForm && (
            <div className={classes.rootGrid}>
              <PregnantEditForm
                id={data.id}
                user={data}
                maestras={maestras}
                setMessage={setMessage}
                message={message}
                setShowMessage={setShowMessage}
                dispatch={dispatch}
                setShowEditForm={setShowEditForm}
                setHasEdition={setHasEdition}
                hasEdition={hasEdition}
              />
            </div>
          )}
          {showDetails && (
            <div className={classes.rootGrid}>
              <Grid container spacing={3}>
                {headers.otherHeaders.map((header) => (
                  <Grid item xs={2}>
                    <Typography className={classes.heading}>
                      {header.title}
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      {getValueByKey(data, header)}
                    </Typography>
                  </Grid>
                ))}



                <Grid item xs={12} >
                  <Divider style={{ marginBottom: "20px" }} />
                  <Typography className={classes.heading} style={{ marginBottom: "10px" }}>
                    Cálculo de lactancia
                  </Typography>
                  {headers.additionalInfo.map((header) => (

                    <Typography className={classes.heading}>
                      <span style={{ width: "85px", display: "inline-block" }}>{header.title}</span>
                      {getValueByKey(data, header)}
                    </Typography>

                  ))}
                </Grid>
                <Grid item xs={10}>
                  &nbsp;
                </Grid>
                <Grid item xs={2}>
                  {showCancelRecordButton(data?.id, data?.status)}
                </Grid>
              </Grid>
            </div>
          )}
        </AccordionDetails>
      </Accordion>

      {showLactationCalculationModal &&
        <LactationCalculationModal
          handleClose={onCloseLactationCalculationModal}
          open={showLactationCalculationModal}
          licenceId={data.id}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
          estimatedDueDate={licenseStartDateValue}
          licenseEndDateValue={licenseEndDateValue}
          setHasEdition={setHasEdition}
          hasEdition={hasEdition}
        />
      }

      {showPregnantDocumentsModal &&
        <PregnantDocumentsModal
          handleClose={onClosePregnantDocumentsModal}
          open={showPregnantDocumentsModal}
          licenceId={data.id}
        />
      }

      {openModal && (
        <PregnantFilesModal
          open={openModal}
          handleClose={onClose}
          setShowMessage={setShowMessage}
          message={message}
          setMessage={setMessage}
          setDocuments={setDocuments}
        />
      )}

      {showMessage && <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={showMessage}
      />}
    </div>
  );
};

export default PregnantAccordion;
